import SharedTranslations, { TranslationField } from "shared/components/Translations";
import { LocaleCode } from "shared/types/languages";
import TranslationInput from "shared/components/Translations/TranslationInput";
import { useTagDetails } from "../../../../context";
import { ManagedTranslations } from "../../../../context/types";

const Translations = () => {
  const { tagName, translations, setTranslations } = useTagDetails()

  const fields: TranslationField[] = [
    {
      key: ManagedTranslations.TagName,
      label: ManagedTranslations.TagName,
      render: ({ language, value, onChange }) => (
        <TranslationInput
          defaultValue={language === LocaleCode.en ? tagName?.input.value : value}
          variant="filled"
          onChange={({ target: { value } }) => {
            if (language === LocaleCode.en) {
              tagName?.setValue(value);
            } else {
              onChange(value);
            }
          }}
        />
      ),
    },
  ];

  return (
    <SharedTranslations
      fields={fields}
      translations={translations}
      setTranslations={setTranslations}
    />
  );
};

export default Translations;